import React from "react";

import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";

const transformChartData = (data) => {

    const result = {};

    data.forEach(item => {

        const month = item.month;

        if (!result[month]) {

            result[month] = {
                month
            };
        }

        result[month][item.placedBy] =
            Number(item.total || 0);
    });

    return Object.values(result).sort(
        (a, b) => {

            const dateA =
                new Date(`01 ${a.month}`);

            const dateB =
                new Date(`01 ${b.month}`);

            return dateA - dateB;
        }
    );
};

const getSortedOfficers = (data) => {

    const totals = {};

    data.forEach(item => {

        const officer = item.placedBy;

        totals[officer] =
            (totals[officer] || 0) +
            Number(item.total || 0);
    });

    return Object.entries(totals)

        // Highest count first
        .sort((a, b) => b[1] - a[1])

        .map(item => item[0]);
};

// ✅ Auto unique vibrant colors
const generateColor = (index, total) => {

    const hue =
        (index * 360) / total;

    // Dark rich colors
    return `hsl(${hue}, 70%, 35%)`;
};
const PlacedByChart = ({ data }) => {

    const chartData =
        transformChartData(data);

    const officers =
        getSortedOfficers(data);

    return (

        <div>

            <h3>
                Placement Officer Report
            </h3>

            <ResponsiveContainer
                width="100%"
                height={500}
            >

                <BarChart
                    data={chartData}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 20
                    }}
                >

                    <CartesianGrid
                        strokeDasharray="3 3"
                    />

                    <XAxis
                        dataKey="month"
                    />

                    <YAxis />

                    <Tooltip
                        itemSorter={(item) =>
                            -item.value
                        }
                        contentStyle={{
                            borderRadius: "10px",
                            border: "1px solid #ddd"
                        }}
                    />

                    <Legend
                        wrapperStyle={{
                            paddingTop: 20
                        }}
                    />
                    {officers.map(
                        (officer, index) => (

                            <Bar
                                key={officer}
                                dataKey={officer}
                                fill={
                                    generateColor(
                                        index,
                                        officers.length
                                    )
                                }
                                radius={[4, 4, 0, 0]}
                                maxBarSize={40}
                            />
                        )
                    )}

                </BarChart>

            </ResponsiveContainer>

        </div>
    );
};

export default PlacedByChart;